import { render, staticRenderFns } from "./approval-activate-vehicle.vue?vue&type=template&id=56330bda&scoped=true&"
import script from "./approval-activate-vehicle.vue?vue&type=script&lang=js&"
export * from "./approval-activate-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56330bda",
  null
  
)

export default component.exports